import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

/**
 * POST 거절하기
 *
 * Endpoint path is modified in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#e6b23c34f39c4232991f9ed46f937121
 */
export function postDocumentsReject({
  documentId,
  message,
  participantId,
  workspaceId,
}: {
  documentId: string;
  message: string;
  participantId: string;
  workspaceId: string;
}) {
  return requestApi({
    url: withDocument(`/workspaces/${workspaceId}/documents/${documentId}/reject`),
    method: 'POST',
    data: {
      participantId,
      message,
    },
    credentials: true,
  });
}
